type TQuery = Record<string, unknown>;

// Objects/arrays are sent JSON-encoded (decoded again in server/utils/params.ts), scalars as-is.
const serialize = (query: TQuery = {}) =>
  Object.fromEntries(
    Object.entries(query)
      .filter(([, value]) => value !== undefined)
      .map(([key, value]) => [key, typeof value === 'object' ? JSON.stringify(value) : value]),
  );

/**
 * Reads CMS (Directus) content through our own `/api/*` server routes.
 * Call it in setup/composable scope: `useRequestFetch` forwards the incoming request headers
 * (cookies, e.g. the Directus preview session) to the server routes during SSR.
 */
export default function useCms() {
  const requestFetch = useRequestFetch();

  return {
    readItems: <T = any>(collection: string, query?: TQuery) =>
      requestFetch<T[]>(`/api/collections/${collection}`, { query: serialize(query) }),
    readItem: <T = any>(collection: string, id: number | string, query?: TQuery) =>
      requestFetch<T>(`/api/collections/${collection}/${id}`, { query: serialize(query) }),
    readSingleton: <T = any>(name: string, query?: TQuery) =>
      requestFetch<T>(`/api/singletons/${name}`, { query: serialize(query) }),
    aggregate: <T = any>(collection: string, query?: TQuery) =>
      requestFetch<T[]>(`/api/aggregate/${collection}`, { query: serialize(query) }),
  };
}
